import { Shield } from 'lucide-react';

import AISparkles from '@/components/common/AISparkles';
import { SelectItem } from '@/components/shadcn/select';
import type { Policy } from '@/features/policies/types';

type Props = {
  value: string;
  policy: Policy;
  isRelevant?: boolean;
};

export default function PolicySelectItem({ value, policy, isRelevant }: Props) {
  return (
    <SelectItem value={value} className="*:[span]:last:flex-1">
      <div className="flex items-center gap-2">
        <Shield />

        <div className="flex flex-col items-start">
          <span className="flex items-center gap-1 text-sm leading-tight">
            {isRelevant && <AISparkles />}
            {policy.name} ({policy.policy_nr})
          </span>

          <span className="text-muted-foreground text-xs">
            {policy.insurance_company}
          </span>
        </div>
      </div>
    </SelectItem>
  );
}
